export const SMALL = 'small';
export const LARGE = 'large';
